import React from 'react';

import { BeraJobSummaryResultProvider } from '@/context/BeraJobSummaryResult';

import { Content } from './Content';

import type { FileForCustomReport } from '@/components/ui/Inputs/types/response/file';
import type { BeraJobSummary } from '@/types/Bera';

interface FinalResultProps {
	file: FileForCustomReport;
	jobSummary: BeraJobSummary;
	onBack: () => void;
}

export function FinalResult({ file, jobSummary, onBack }: Readonly<FinalResultProps>): JSX.Element {
	return (
		<BeraJobSummaryResultProvider file={file} jobSummary={jobSummary}>
			<Content onBack={onBack} />
		</BeraJobSummaryResultProvider>
	);
}
